import { render } from "./ServicesPageTwo.vue?vue&type=template&id=1310a3ea"
import script from "./ServicesPageTwo.vue?vue&type=script&lang=js"
export * from "./ServicesPageTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__